<template>
  <content-box :width="'430px'">
      <div class="state__warning">
        <i class="icon icon--exclamation-size50"></i>
        <p class="title">{{ $t('userInfo.coupon.warning.title') }}</p>
        <p class="desc" v-html="$t('userInfo.coupon.warning.desc', {
          pv: remainPvComma,
          couponPlanName: planData.planName
        })"></p>
        <div class="checkbox--wrap">
          <ui-checkbox :value="model" @input="toggleCheckBox">
            {{ $t('userInfo.coupon.warning.check') }}
          </ui-checkbox>
          <strong class="validation-text" v-if="modelError">{{ $t(`common.validationErrorText.${modelError}`) }}</strong>
        </div>
        <div class="button--wrap">
          <ui-button @click="onCloseLayer('cancel')">{{ $t('common.cancel') }}</ui-button>
          <ui-button class="btn__confirm"
                     :primary2="true"
                     @click="onConfirmChangePlan">{{ $t('common.confirm') }}</ui-button>
        </div>
      </div>
  </content-box>
</template>

<script>
import { mapState } from 'vuex'
import { thousand } from '@/libs/utils'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiCheckbox from '@/components/ui/UiCheckbox'

export default {
  components: {
    ContentBox,
    UiButton,
    UiCheckbox
  },
  data () {
    return {
      model: '',
      modelError: ''
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData'
    ]),
    remainPvComma () {
      return thousand(this.userData.remainPv)
    }
  },
  methods: {
    toggleCheckBox (value) {
      this.model = value
      this.modelError = ''
    },
    onConfirmChangePlan () {
      if (!this.model) {
        this.modelError = 'requiredAgree'
      } else {
        this.$emit('onConfirm')
        this.onCloseLayer()
      }
    },
    onCloseLayer (isCancel = false) {
      if (isCancel) {
        this.$emit('closeLayer', true)
      } else {
        this.$emit('closeLayer', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.content--wrap {
  text-align: center;
  padding-top: 40px;
  padding-bottom: 25px;

  .title {
    font-size: 20px;
    font-weight: 600;
    color: #444444;
  }

  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
  }

  .state__warning {
    padding-left: 30px;
    padding-right: 30px;
    .title {
      margin-top: 15px;
    }
    .desc {
      margin-top: 12px;
    }
    .checkbox--wrap {
      position: relative;
      width: 100%;
      text-align: center;
      border-top: 1px solid #d8d8d8;
      margin-top: 25px;
      padding-top: 20px;

      /deep/ .text {
        font-size: 13px;
        color: #666666;
      }
    }
    .validation-text {
      @include validErrorText;
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      text-align: center;
      width: 100%;
    }
    .button--wrap {
      margin-top: 25px;
      .btn__confirm {
        margin-left: 5px;
      }
    }
  }
}
</style>
